export const getFrontendVersionMetadata = () => {
  const commitHash = process.env.REACT_APP_FRONTEND_COMMIT_HASH || '';

  return {
    label: 'UI',
    name: 'OikoBrowser Frontend',
    version: process.env.REACT_APP_FRONTEND_VERSION || '0.1.0',
    commit_hash: commitHash,
    commit_short: commitHash ? commitHash.slice(0, 7) : '',
    commit_url: process.env.REACT_APP_FRONTEND_COMMIT_URL || '',
  };
};
